import { gql } from "@apollo/client";
import { CONTENT_BLOCK_PREVIEW_FRAGMENT } from "../ContentBlocks/contentBlockQueries"

export const GET_CATEGORIES_FOR_SELECT = gql`
  query GET_CATEGORIES_FOR_SELECT {
    findManyCategory {
      id
      product_containers {
        id
      }
      category_profiles {
        id
        name
        language
      }
      banners {
        id
        src
      }
      image {
        id
        src
      }
    }
  }
`;

// Dedicated query for the CTA internal-target picker (`CtaTargetSelect`).
// Kept separate from `GET_CATEGORIES_FOR_SELECT` (used by the category_tiles
// content block) so that consumer isn't disturbed by picker-specific fields
// (parent id for the tree, permalink for the portal's href resolution).
export const GET_CATEGORIES_FOR_CTA_PICKER = gql`
  query GET_CATEGORIES_FOR_CTA_PICKER {
    findManyCategory {
      id
      parent_categoryId
      category_profiles {
        language
        name
        meta_information {
          permalink
        }
      }
    }
  }
`;

export const DELETE_CATEGORY = gql`
  mutation DeleteCategory($where: CategoryWhereUniqueInput!) {
    deleteOneCategory(where: $where) {
      id
    }
  }
`;

export const DELETE_MANY_CATEGORIES = gql`
  mutation DELETE_CATEGORIES($ids: [Int!]!) {
    deleteManyCategory(where: { id: { in: $ids } }) {
      count
    }
  }
`;

export const GET_CATEGORIES = gql`
  query GET_CATEGORIES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [CategoryOrderByWithRelationInput!]
  ) {
    findManyCategory(
      where: {
        category_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      category_profiles {
        id
        name
        language
      }
      product_containers {
        id
      }
      createdAt
      updatedAt
    }
    findManyCategoryCount(
      where: {
        category_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`;

export const GET_CATEGORY = gql`
  ${CONTENT_BLOCK_PREVIEW_FRAGMENT}
  query GetCategory($id: Int!) {
    findUniqueCategory(where: { id: $id }) {
      id
      image_icon {
        id
        src
      }
      image {
        id
        src
      }
      banners {
        id
        src
      }
      parent_categoryId
      schema_href
      code
      show_in_menu
      is_root_category
      erp_synced
      menu_order
      content_blocks {
        ...ContentBlockPreviewFields
        arrangement
        video_type
        video_link
      }
      category_profiles {
        id
        name
        description
        language
        meta_information {
          id
          permalink
          meta_title
          meta_description
        }
      }
      product_containers {
        id
      }
    }
  }
`;

export const CREATE_CATEGORY = gql`
  mutation CREATE_CATEGORY(
    $category_profiles: [CategoryProfileCustomInput!]!
    $image_icon: [String]
    $image: [String]
    $banners: [String]
    $parent_categoryId: Int
    $schema_href: String
    $code: String
    $selected_products: [ProductContainerWhereUniqueInput]!
    $show_in_menu: Boolean!
    $is_root_category: Boolean
    $erp_synced: Boolean
    $menu_order: Int
    $content_blocks: [ContentBlockWhereUniqueInput]
  ) {
    createNewCategory(
      category_profiles: $category_profiles
      image_icon: $image_icon
      image: $image
      banners: $banners
      parent_categoryId: $parent_categoryId
      schema_href: $schema_href
      code: $code
      selected_products: $selected_products
      show_in_menu: $show_in_menu
      is_root_category: $is_root_category
      erp_synced: $erp_synced
      menu_order: $menu_order
      content_blocks: $content_blocks
    ) {
      id
    }
  }
`;

export const UPDATE_CATEGORY = gql`
  mutation UPDATE_CATEGORY(
    $where: CategoryWhereUniqueInput!
    $category_profiles: [CategoryProfileCustomInput!]!
    $image_icon: [String]
    $image: [String]
    $banners: [String]
    $parent_categoryId: Int
    $schema_href: String
    $code: String
    $selected_products: [ProductContainerWhereUniqueInput]!
    $show_in_menu: Boolean!
    $is_root_category: Boolean
    $erp_synced: Boolean
    $menu_order: Int
    $content_blocks: [ContentBlockWhereUniqueInput]
  ) {
    updateExistingCategory(
      where: $where
      category_profiles: $category_profiles
      image_icon: $image_icon
      image: $image
      banners: $banners
      parent_categoryId: $parent_categoryId
      schema_href: $schema_href
      code: $code
      selected_products: $selected_products
      show_in_menu: $show_in_menu
      is_root_category: $is_root_category
      erp_synced: $erp_synced
      menu_order: $menu_order
      content_blocks: $content_blocks
    ) {
      id
    }
  }
`;

export const GET_CATEGORIES_TREE = gql`
  query GET_CATEGORIES_TREE {
    getCategoriesAndChildsQuery(
      orderBy: [{ menu_order: asc }]
    ) {
      id
      depth_level
      parent_categoryId
      menu_order
      code
      category_profiles {
        id
        name
        language
      }
      product_containers {
        id
      }
      child_categories {
        id
      }
    }
  }
`;
